import angular from 'angular';

import {emojiPicker} from './emojiPicker.directive.js';
import {emojiPicker2ModalController} from './emojiPicker2.controller';
angular
  .module('emoji-picker', [])
  .directive('emojiPicker', emojiPicker)
  .controller('emojiPicker2ModalController', emojiPicker2ModalController)
  ;
